import { createSlice } from "@reduxjs/toolkit";
import { SponsorState } from "../types/state";
import { LOADING } from "../../../types";
import { addSponsor } from "../actions/add";
import { deleteSponsor } from "../actions/delete";
import { toggleSponsorVisibility } from "../actions/toggleVisibility";
import { setSponsorError } from "../actions/setError";
import { setSponsorData } from "../actions/setData";

const initialState: SponsorState = {
  data: null,
  loading: LOADING.IDLE,
  loaded: LOADING.IDLE,
  error: null,
};

export const sponsorSlice = createSlice({
  name: "sponsor",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(setSponsorError, (state, { payload: error }) => {
        state.error = error;
        state.loading = LOADING.IDLE;
        state.data = null;
      })
      .addCase(setSponsorData, (state, { payload: sponsors }) => {
        state.data = sponsors;
        state.error = null;
        state.loading = LOADING.IDLE;
      })
      .addCase(addSponsor.fulfilled, (state) => {
        state.error = null;
        state.loading = LOADING.IDLE;
      })
      .addCase(addSponsor.rejected, (state, { payload: error }) => {
        state.loading = LOADING.IDLE;
        state.error = error as string | null;
      })
      .addCase(addSponsor.pending, (state) => {
        state.loading = LOADING.PENDING;
        state.error = null;
      })
      .addCase(deleteSponsor.fulfilled, (state) => {
        state.error = null;
        state.loading = LOADING.IDLE;
      })
      .addCase(deleteSponsor.rejected, (state, { payload: error }) => {
        state.loading = LOADING.IDLE;
        state.error = error as string | null;
      })
      .addCase(deleteSponsor.pending, (state) => {
        state.loading = LOADING.PENDING;
        state.error = null;
      })
      .addCase(toggleSponsorVisibility.fulfilled, (state) => {
        state.error = null;
        state.loading = LOADING.IDLE;
      })
      .addCase(
        toggleSponsorVisibility.rejected,
        (state, { payload: error }) => {
          state.loading = LOADING.IDLE;
          state.error = error as string | null;
        },
      )
      .addCase(toggleSponsorVisibility.pending, (state) => {
        state.loading = LOADING.PENDING;
        state.error = null;
      });
  },
});
